module.exports = __webpack_public_path__ + "static/media/buy_change_request_2.28f2cb86.png";